/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderInfoVo
 */
export interface OrderInfoVo {
    /**
     * 订单id
     * @type {number}
     * @memberof OrderInfoVo
     */
    orderId?: number;
    /**
     * 订单号
     * @type {string}
     * @memberof OrderInfoVo
     */
    orderCode?: string;
    /**
     * 区域
     * @type {string}
     * @memberof OrderInfoVo
     */
    zone?: string;
    /**
     * 库位
     * @type {string}
     * @memberof OrderInfoVo
     */
    location?: string;
    /**
     * 附加服务
     * @type {string}
     * @memberof OrderInfoVo
     */
    additionalService?: string;
    /**
     * 备注
     * @type {string}
     * @memberof OrderInfoVo
     */
    remark?: string;
    /**
     * 仓库备注
     * @type {string}
     * @memberof OrderInfoVo
     */
    warehouseRemarkCn?: string;
    /**
     * 仓库备注
     * @type {string}
     * @memberof OrderInfoVo
     */
    warehouseRemarkKr?: string;
    /**
     * 所有快递单号
     * @type {string}
     * @memberof OrderInfoVo
     */
    allParcelTrackingNumber?: string;
    /**
     * 接收人配送要求
     * @type {string}
     * @memberof OrderInfoVo
     */
    receiverDeliveryRequirement?: string;
    /**
     * 唛头号
     * @type {string}
     * @memberof OrderInfoVo
     */
    markNos?: string;
}

/**
 * Check if a given object implements the OrderInfoVo interface.
 */
export function instanceOfOrderInfoVo(value: object): value is OrderInfoVo {
    return true;
}

export function OrderInfoVoFromJSON(json: any): OrderInfoVo {
    return OrderInfoVoFromJSONTyped(json, false);
}

export function OrderInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'zone': json['zone'] == null ? undefined : json['zone'],
        'location': json['location'] == null ? undefined : json['location'],
        'additionalService': json['additionalService'] == null ? undefined : json['additionalService'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'warehouseRemarkCn': json['warehouseRemarkCn'] == null ? undefined : json['warehouseRemarkCn'],
        'warehouseRemarkKr': json['warehouseRemarkKr'] == null ? undefined : json['warehouseRemarkKr'],
        'allParcelTrackingNumber': json['allParcelTrackingNumber'] == null ? undefined : json['allParcelTrackingNumber'],
        'receiverDeliveryRequirement': json['receiverDeliveryRequirement'] == null ? undefined : json['receiverDeliveryRequirement'],
        'markNos': json['markNos'] == null ? undefined : json['markNos'],
    };
}

export function OrderInfoVoToJSON(json: any): OrderInfoVo {
    return OrderInfoVoToJSONTyped(json, false);
}

export function OrderInfoVoToJSONTyped(value?: OrderInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'zone': value['zone'],
        'location': value['location'],
        'additionalService': value['additionalService'],
        'remark': value['remark'],
        'warehouseRemarkCn': value['warehouseRemarkCn'],
        'warehouseRemarkKr': value['warehouseRemarkKr'],
        'allParcelTrackingNumber': value['allParcelTrackingNumber'],
        'receiverDeliveryRequirement': value['receiverDeliveryRequirement'],
        'markNos': value['markNos'],
    };
}

